export type LoginErrorKey =
  | "invalid_credentials"
  | "disabled"
  | "not_invited"
  | "network"
  | "rate_limited"
  | "unknown";

const LOGIN_ERROR_KEYS: readonly LoginErrorKey[] = [
  "invalid_credentials",
  "disabled",
  "not_invited",
  "network",
  "rate_limited",
  "unknown",
];

export function mapLoginError(err: unknown): LoginErrorKey {
  if (err instanceof TypeError) return "network";
  const e = (err ?? {}) as { message?: string; status?: number; name?: string };
  // supabase-js wraps fetch failures in AuthRetryableFetchError (status 0)
  if (e.status === 0 || e.name === "AuthRetryableFetchError") return "network";
  const m = (typeof err === "string" ? err : (e.message ?? "")).toLowerCase();
  const prefix = "gavion.login.errors.";
  if (m.startsWith(prefix)) {
    const k = m.slice(prefix.length) as LoginErrorKey;
    if (LOGIN_ERROR_KEYS.includes(k)) return k;
  }
  if (e.status === 429 || m.includes("rate limit")) return "rate_limited";
  if (m.includes("not_invited")) return "not_invited";
  if (m.includes("account_disabled")) return "disabled";
  if (m.includes("invalid login credentials")) return "invalid_credentials";
  return "unknown";
}

type LocationLike = { hash: string; search: string };

// OAuth failures come back in the URL: `#error=...` (implicit) or `?error=...`.
export function parseAuthReturnError(loc: LocationLike): LoginErrorKey | null {
  const hash = loc.hash.replace(/^#/, "");
  const hashQuery = hash.includes("?")
    ? hash.slice(hash.indexOf("?") + 1)
    : hash;
  for (const raw of [hashQuery, loc.search.replace(/^\?/, "")]) {
    const p = new URLSearchParams(raw);
    const desc = p.get("error_description");
    if (desc !== null || p.get("error") !== null) {
      return mapLoginError({ message: desc ?? p.get("error") ?? "" });
    }
  }
  return null;
}
